import React, { useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { MASTER_LOGIN } from '../../utils/api'; // ✅ Update path if needed
import axiosInstance from '../../config/axiosInstance'; // ✅ Update path if needed
import { useNavigate } from 'react-router-dom';

function MasterLogin() {
  const [form, setForm] = useState({ mobile: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const goBack = () => {
    navigate('/'); // Navigates to Welcome Page
  };

  const handleLogin = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const res = await axiosInstance.post(MASTER_LOGIN, form);
      console.log('Login response:', res.data);

      if (res.data?.success) {
        toast.success(res.data.message || 'Login successful');
        localStorage.setItem('token', res.data.token);

        setTimeout(() => {
          navigate('/master-dashboard');
        }, 1000);
      } else {
        toast.error(res.data.message || 'Login failed');
        setError(res.data.message || 'Login failed');
      }
    } catch (err) {
      const msg = err?.response?.data?.message || 'Unable to login, please try again';
      toast.error(msg);
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <Toaster position="top-center" />
      <div className="card shadow p-4 w-100" style={{ maxWidth: '400px' }}>
        <h3 className="text-center mb-4">Master Login</h3>

        <input
          type="text"
          className="form-control mb-3"
          name="mobile"
          placeholder="Mobile"
          value={form.mobile}
          onChange={handleChange}
        />

        <input
          type="password"
          className="form-control mb-3"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
        />

        {error && <div className="text-danger mb-3">{error}</div>}

        <button
          className="btn btn-primary w-100"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
         {/* ✅ Back Button */}
        <button className="btn btn-outline-secondary w-100" onClick={goBack}>
          ⬅️ Back
        </button>
      </div>
    </div>
  );
}

export default MasterLogin;
